import SignupService from "./signupService";

export default SignupService;
